import { useRuntimeConfig } from 'nuxt/app'
import type { ServiceEndpoints } from '@packages/app-config'

// 此文件用于判断当前环境（测试环境/生产环境），并返回对应环境的接口域名
const WIKITRADE_API = 'https://wikitrade.interface002.com:32377'

const development: ServiceEndpoints = {
  // 测试环境
  ipServer: 'http://ipinversion.fxeyeinterface.com',
  homeClient: `https://wikidatacenter.${TECH002}:32377`,
  testwikidatacenter: 'http://bit.wikidatacenter.fxeyeinterface.com:32366',
  ipTranslet: `https://exportedbase.${TECH002}`,
  host: 'http://wikiuapi.fxeyeinterface.com',
  osshost: 'https://head-sg.oss-ap-southeast-1-internal.aliyuncs.com',
  v4: `https://api-gw.${TECH002}`,
  wikibitBffGo: 'http://api-wikibitbff-go.fxeyeinterface.com',
  wikibitsearch: 'http://wikibitsearch.fxeyeinterface.com',
  wikibitDatahubGo: 'http://api-datahub-go.fxeyeinterface.com',
  wikilicenseGo: 'http://api-wikilicense-go.fxeyeinterface.com',
  wikitrade: WIKITRADE_API,
}

const production: ServiceEndpoints = {
  // 生产环境
  ipServer: 'http://ipinversion.fxeyeinterface.com',
  homeClient: `https://wikidatacenter.${TECH002}:32377`,
  testwikidatacenter: 'http://bit.wikidatacenter.fxeyeinterface.com:32366',
  ipTranslet: `https://exportedbase.${TECH002}`,
  host: 'http://wikiuapi.fxeyeinterface.com',
  osshost: 'https://head-sg.oss-ap-southeast-1-internal.aliyuncs.com',
  v4: `https://api-gw.${TECH002}`,
  wikibitBffGo: 'http://api-wikibitbff-go.fxeyeinterface.com',
  wikibitsearch: 'http://wikibitsearch.fxeyeinterface.com',
  wikibitDatahubGo: 'http://api-datahub-go.fxeyeinterface.com',
  wikilicenseGo: 'http://api-wikilicense-go.fxeyeinterface.com',
  wikitrade: WIKITRADE_API,
}

// 生产环境标识集合（fangzhen 视为生产环境）
const productionEnvs = new Set(['production', 'fangzhen'])

/**
 * 通过 Nuxt runtimeConfig 获取当前环境标识（对应 .env.xxx 中的 NUXT_APP_ENV），
 * 返回对应环境的接口域名配置。
 *
 * - production / fangzhen → 生产配置
 * - development / test / 其他 → 测试配置
 *
 * @example
 * ```ts
 * const api = useEnvApi()
 * console.log(api.host)  // => 'http://wikiuapi.fxeyeinterface.com'
 * console.log(api.v4)    // => 'https://api-gw.TECH002.com'
 * ```
 */
export const useEnvApi = (): ServiceEndpoints => {
  const runtimeConfig = useRuntimeConfig()
  const env = runtimeConfig.public.appEnv as string

  return productionEnvs.has(env) ? production : development
}
